define('score_bootstrap/Models/Comments/PostCommentModel',[], function () {
    "use strict";



    function PostCommentModel(id, componentId, commentText, postDate, rootId, postCommentAction, userTimeOffset, userLanguage) {
        var instance = {
                id: id,
                componentId: componentId,
                commentText: commentText,
                postDate: postDate,
                rootId: rootId,
                postCommentAction: postCommentAction,
                userTimeOffset: userTimeOffset,
                userLanguage: userLanguage
            };

        Object.defineProperties(this, {
            id: {
                enumerable: true,
                get: function () { return instance.id; },
                set: function (value) {
                    instance.id = value;
                }
            },
            componentId: {
                enumerable: true,
                get: function () { return instance.componentId; },
                set: function (value) {
                    instance.componentId = value;
                }
            },      
            commentText: {
                enumerable: true,
                get: function () { return instance.commentText; },
                set: function (value) {
                    instance.commentText = value;
                }
            },
            postDate: {
                enumerable: true,
                get: function () { return instance.postDate; },
                set: function (value) {
                    instance.postDate = value;
                }
            },
            rootId: {
                enumerable: true,
                get: function () { return instance.rootId; },
                set: function (value) {
                    instance.rootId = value;
                }
            },
            postCommentAction: {
                enumerable: true,
                get: function () { return instance.postCommentAction; },
                set: function (value) {
                    instance.postCommentAction = value;
                }
            },
            userTimeOffset:  {
                enumerable: true,
                value: userTimeOffset
            },
            userLanguage:  {
                enumerable: true,
                value: userLanguage
            }
        });
    }

    return PostCommentModel;
});
